import { Fragment } from "react";
import { Popover, Transition } from "@headlessui/react";

const projects = [
  {
    name: "Smith AI",
    category: "software",
    description:
      "Built an AI platform in 36 hours that deploys AI-powered agents with HTML, JavaScript, Tailwind, Flask, CSS, AWS, and MongoDB on the back end. Recognized with awards including Best Use of Generative AI (MLH) and Best Cloud Implementation (Caterpillar), and most likely to be business (Purdue Innovates).",
    submission: "https://devpost.com/software/smithai",
    source: "./assets/Projects/SmithAI.png",
    code: "",
    link: "",
  },

  {
    name: "RefugeForUkraine Website",
    category: "software",
    description:
      "This award winning website was designed to track the Russia-Ukraine War visually to send help where it’s most needed.",
    code: "https://replit.com/@KamyaMiles/Refuge-for-Ukraine?v=1",
    source: "./assets/Projects/RefugeForUkraine.jpg",
    link: "https://refuge-for-ukraine.kamyamiles.repl.co/",
    submission: "https://devpost.com/software/refuge-for-ukraine",
  },

  {
    name: "NASA Prototype Finalist",
    category: "hardware",
    description:
      "We created an insect nanolab in the NASA HUNCH Program. The goal was to have the project exist on the ISS (and eventually Mars) to house crickets as a food source for astronauts. NASA HUNCH is a club at our school, but all work was done outside of class and was completely self-guided. Our team was selected as top five in the county, which is the highest award, called “Finalists.”",
    source: "./assets/Projects/Hunch.png",
    submission: false,
    code: false,
    link: "https://docs.google.com/presentation/d/19nf-KUYmez19IdhO7vigz0R1mJswV-PWZuXSmNJG9Vg/edit?usp=sharing",
  },
];

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

function ProjectGrid({ items }) {
  return (
    <ul className="grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2 xl:gap-x-8">
      {items.map((project) => (
        <li key={project.name} className="relative">
          <Popover>
            {({ open }) => (
              <>
                <Popover.Button>
                  <div
                    className={classNames(
                      open
                        ? "ring-2 ring-offset-2 ring-cyan-500"
                        : "focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-offset-gray-100 focus-within:ring-cyan-500",
                      "group block w-full aspect-w-10 aspect-h-7 rounded-lg bg-gray-100 overflow-hidden"
                    )}
                  >
                    <img
                      src={project.source}
                      alt=""
                      className={classNames(
                        open ? "" : "group-hover:opacity-75",
                        "object-cover pointer-events-none"
                      )}
                    />
                  </div>
                </Popover.Button>

                <Transition
                  as={Fragment}
                  enter="transition ease-out duration-200"
                  enterFrom="opacity-0 -translate-y-1"
                  enterTo="opacity-100 translate-y-0"
                  leave="transition ease-in duration-150"
                  leaveFrom="opacity-100 translate-y-0"
                  leaveTo="opacity-0 -translate-y-1"
                >
                  <Popover.Panel className="z-10 transform shadow-lg">
                    <div className="bg-customGray text-white rounded-lg p-5 w-fit z-10">
                      <div className="text-center">
                        <h1 className="md:text-4xl text-2xl font-bold mb-3">
                          {project.name}
                        </h1>
                        <p className="mb-2">{project.description}</p>
                        <p>
                          Source Code:{" "}
                          {project.code ? (
                            <a className="underline" href={project.code}>
                              Here
                            </a>
                          ) : (
                            "Not available"
                          )}
                        </p>
                        <p>
                          Competition Submission:{" "}
                          {project.submission ? (
                            <a className="underline" href={project.submission}>
                              Here
                            </a>
                          ) : (
                            "Not available"
                          )}
                        </p>
                        <p>
                          Live Website:{" "}
                          {project.link ? (
                            <a className="underline" href={project.link}>
                              Here
                            </a>
                          ) : (
                            "Not available"
                          )}
                        </p>
                      </div>
                    </div>
                  </Popover.Panel>
                </Transition>
              </>
            )}
          </Popover>
        </li>
      ))}
    </ul>
  );
}

export default function Gallary() {
  const hardwareProjects = projects.filter((p) => p.category === "hardware");
  const softwareProjects = projects.filter((p) => p.category === "software");

  return (
    <div>
      {/* Hardware Projects */}
      {hardwareProjects.length > 0 && (
        <section className="mt-8 pb-16">
          <h2 className="text-2xl font-semibold text-white text-center mb-6">
            Hardware Projects
          </h2>
          <ProjectGrid items={hardwareProjects} />
        </section>
      )}

      {/* Software Projects */}
      <section className="mt-8 pb-16">
        <h2 className="text-2xl font-semibold text-white text-center mb-6">
          Software Projects
        </h2>
        <ProjectGrid items={softwareProjects} />
      </section>
    </div>
  );
}
